
      import { initializeCommunication } from '/src/utils/communicationChannel.ts';
      initializeCommunication();
    